function DashboardActiveMainRPMandGear( {value} ) {
    const rpm_bar_width = Math.trunc(((value.rpm)/(value["max-rpm"]))*100)

    return (
        <div className="flex flex-col items-center gap-2">
            <div className="w-full bg-[#111a22] h-6 rounded border border-[#324d67] overflow-hidden relative">
                <div className="rpm-bar h-full shadow-[0_0_15px_rgba(11,218,91,0.3)] transition-[width] duration-50 linear" style={{ width: `${rpm_bar_width}%` }}></div>
                <div className="absolute inset-0 flex items-center justify-between px-2">
                    <span className="text-[10px] font-black text-white mix-blend-difference uppercase">RPM</span>
                    <span className="text-[10px] font-black text-white mix-blend-difference">{value.rpm}</span>
                </div>
            </div>
            <div className="relative flex h-32 w-full items-center justify-center rounded-xl bg-gradient-to-br from-[#233648] to-[#111a22] border border-[#324d67] overflow-hidden">
                <span className="gear-text text-8xl font-black text-primary italic">{value.gear}</span>
                <div className="absolute bottom-2 right-3 flex flex-col items-end">
                    <span className="text-[10px] font-bold text-[#92adc9] uppercase">Speed</span>
                    <span className="text-xl font-bold">{Math.trunc(value.speed)} <span className="text-xs text-[#92adc9]">km/h</span></span>
                </div>
            </div>
        </div>
    );
}

export default DashboardActiveMainRPMandGear;